import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import './Leadgeneration.css';
import { FaUserPlus, FaSearch, FaInfoCircle, FaTrash } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { IoOpenOutline } from "react-icons/io5";


const customStylesRes = {
    content: {
      position: 'absolute',
      border: '1px solid rgb(204, 204, 204)',
      background: 'rgb(255, 255, 255)',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      top: '60px',
      left: '50%',
      padding: '20px',
      transform: 'translate(-50%, 0%)',
      width: '100%',
      maxWidth: '85%',
      height: '100%',
      maxHeight: '90%',
    }
  }

const Leadgeneration = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [CardData, setCardData] = useState({});
  const navigate = useNavigate();
  const [pageinationdata, setPageinationdata] = useState({
    "total": 0,
    "currentPage": 1,
    "totalPages": 0,
    "limit": 10,
    "startItem": 0,
    "endItem": 0,
    "hasNextPage": false,
    "hasPrevPage": false
  });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: ''
  });
  const [leadList, setLeadList] = useState([]);

  const getLeads = async () => {
    try {
      const response = await fetch(`https://api.experts4u.in/api/v2/Leadgeneration/getLeadgeneration?page=${page}&limit=${limit}&search=${search}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const result = await response.json();
      
      if (result.success) {
        const transformedData = result.data.map(lead => ({
          ...lead,
          status: lead.status ? 'Success' : 'Pending'
        }));
        setLeadList(transformedData);
        setPageinationdata(result.pagination);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No data found',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('Error fetching leads:', error);
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 1500
      });
    }
  }

  useEffect(() => {
    getLeads();
  }, [page, limit, search]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phoneNumber') {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prevState => ({
        ...prevState,
        [name]: numericValue
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://api.experts4u.in/api/v2/Leadgeneration/addLeadgeneration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phoneNumber,
          status: false
        })
      });

      const result = await response.json();
      
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Lead added successfully',
          showConfirmButton: false,
          timer: 1500
        });
        getLeads();
        closeModal();
        setFormData({ name: '', email: '', phoneNumber: '' });
      } else {
        Swal.fire({
          icon: 'error',
          title: result.message || 'Failed to add lead',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('Error adding lead:', error);
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };

  const handleStatusUpdate = async (leadId, newStatus) => {
    try {
      const response = await fetch(`https://api.experts4u.in/api/v2/Leadgeneration/updateLeadStatus/${leadId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          status: newStatus === 'Success'
        })
      });

      const result = await response.json();
      
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Status updated successfully',
          showConfirmButton: false,
          timer: 1500
        });
        getLeads();
      } else {
        Swal.fire({
          icon: 'error',
          title: result.message || 'Failed to update status',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('Error updating status:', error);
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDelete = async (leadId) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      });

      if (result.isConfirmed) {
        const response = await fetch(`https://api.experts4u.in/api/v2/Leadgeneration/deleteLeadgeneration/${leadId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        const data = await response.json();
        
        if (data.success) {
          Swal.fire({
            icon: 'success',
            title: 'Lead deleted successfully',
            showConfirmButton: false,
            timer: 1500
          });
          getLeads();
        } else {
          Swal.fire({
            icon: 'error',
            title: data.message || 'Failed to delete lead',
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    } catch (error) {
      console.error('Error deleting lead:', error);
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };

  return (
    <div className="container-fluid py-5 leadgeneration-component">
      <div className="row justify-content-center">
        <div className="col-md-11">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <h4 className="mb-0">Lead Generation</h4>
                <span className="badge bg-primary ms-3 text-white" style={{ fontSize: '0.9rem', padding: '0.5rem 1rem' }}>
                  {pageinationdata.total} Total Leads
                </span>
              </div>
              <div className="d-flex align-items-center">
                <div className="search-box me-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search leads by name, email or phone..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <FaSearch className="search-icon" />
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Date & Time</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leadList?.map((lead) => (
                      <tr key={lead._id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="ms-2">
                              <div className="fw-medium">{lead.name}</div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <a href={`mailto:${lead.email}`} className="text-decoration-none">
                            {lead.email}
                          </a>
                        </td>
                        <td>
                          <a href={`tel:${lead.phone}`} className="text-decoration-none">
                            {lead.phone}
                          </a>
                        </td>
                        <td>
                          <span className="text-muted">
                            {new Date(lead?.date).toLocaleString()}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex justify-content-center gap-5 gpppp">
                            <button 
                              className="btn btn-sm btn-info d-flex align-items-center gap-1" 
                              onClick={()=>{setCardData(lead?.data);openModal()}}
                              title="View Details"
                            >
                              <FaInfoCircle /> View
                            </button>
                            <button 
                              className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                              onClick={()=>{navigate("/createleadjob",{state:{data:lead}})}}
                              title="Create Job"
                            >
                              <IoOpenOutline /> Create Job
                            </button>
                            <button 
                              className="btn btn-sm btn-danger d-flex align-items-center gap-1"
                              onClick={() => handleDelete(lead._id)}
                              title="Delete Lead"
                            >
                              <FaTrash /> Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="card-footer d-flex justify-content-between align-items-center pt-3 bg-light px-3 pb-3">
                <div className="d-none d-md-block">
                  <span className="text-muted">
                    Showing {pageinationdata.startItem || 0}-{pageinationdata.endItem || 0} of {pageinationdata.total || 0} leads
                  </span>
                </div>
                {(pageinationdata.totalPages > 1) && (
                  <nav aria-label="Page navigation" className="mx-auto mx-md-0">
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(1)}
                          disabled={!pageinationdata.hasPrevPage}
                          title="First Page"
                        >
                          <span aria-hidden="true">&laquo;&laquo;</span>
                        </button>
                      </li>
                      <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(page - 1)}
                          disabled={!pageinationdata.hasPrevPage}
                          title="Previous Page"
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      
                      {(() => {
                        const totalPages = pageinationdata.totalPages || 0;
                        const pagesPerGroup = 6;
                        let startPage = Math.max(1, page - Math.floor(pagesPerGroup / 2));
                        let endPage = Math.min(totalPages, startPage + pagesPerGroup - 1);
                        
                        if (endPage - startPage + 1 < pagesPerGroup) {
                          startPage = Math.max(1, endPage - pagesPerGroup + 1);
                        }
                        
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        
                        return pageNumbers.map(pageNum => (
                          <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => handlePageChange(pageNum)}
                              title={`Page ${pageNum}`}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      
                      <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(page + 1)}
                          disabled={!pageinationdata.hasNextPage}
                          title="Next Page"
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                      <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(pageinationdata.totalPages || 1)}
                          disabled={!pageinationdata.hasNextPage}
                          title="Last Page"
                        >
                          <span aria-hidden="true">&raquo;&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStylesRes}
        contentLabel="Lead Details"
      >
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">Lead Details</h4>
              <button className="btn btn-sm btn-danger d-flex align-items-center gap-1" onClick={closeModal}>
                <IoMdClose /> Close
              </button>
            </div>
            <div className="card-body">
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Service</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {CardData?.cart?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="fw-semibold mb-1">{item?.packageTitle}</div>
                        <ul className="list-unstyled mb-0">
                          {item?.packageName?.map((pkg, idx) => (
                            <li key={idx} className="text-muted small">
                              {pkg}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td>{item?.quantity}</td>
                      <td>₹ {item?.packagetotalPrice}</td>
                      <td>₹ {Number(item?.packagetotalPrice) * Number(item?.quantity)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Leadgeneration
